<section id="section-report" class="container-fluid mt-1">
  <div class="row">
    <div id="container-print" class="col-12 col-lg-12">
      <table id="main-table">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{maintenanceOrderPrintContract.maintenanceOrderId}}" class="head col-12 col-lg-12">
                  <!-- Logo -->
                  <img id="logo-{{maintenanceOrderPrintContract.maintenanceOrderId}}" [src]="logoEnterprise" alt=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">

                  <!--Nombre Empresa -->
                  <p id="nombre-empresa-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintContract.enterpriseName}}</p>

                  <!--Nombre Sucursal -->
                  <p id="nombre-sucursal-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintContract.branchName}}</p>

                  <!--Clase de Orden de Mantenimiento -->
                  <p id="orden-mantenimiento-clase-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">ORDEN DE MANTENIMIENTO PROGRAMADA</p>

                  <!-- Orden de Mantenimiento Consecutivo -->
                  <label id="t-orden-mantenimiento-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-orden-mantenimiento' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="orden-mantenimiento-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintContract.consecutive}}
                  </p>

                  <!-- Orden de Mantenimiento Fecha -->
                  <label id="t-orden-mantenimiento-fecha-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-orden-mantenimiento-fecha' | formatLabelPipe : elementsLabel}}</label>
                  <p id="orden-mantenimiento-fecha-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintContract.dateMaintenanceOrder | date: 'dd/MM/yyyy'}}</p>

                  <!-- Cliente -->
                  <label id="t-cliente-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-cliente' | formatLabelPipe : elementsLabel}}</label>
                  <p id="cliente-{{maintenanceOrderPrintContract.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{maintenanceOrderPrintContract.clientName}}</p>


                  <!-- Centro de Costos  -->
                  <label id="t-centro-costos-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-centro-costos' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="centro-costos-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintContract.costCenterName}}</p>

                  <!-- Obra  -->
                  <label id="t-obra-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-obra' | formatLabelPipe :
                    elementsLabel}}
                  </label>
                  <p id="obra-{{maintenanceOrderPrintContract.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{maintenanceOrderPrintContract.constructionSiteName}}</p>

                  <!-- Dirección Obra  -->
                  <label id="t-direccion-obra-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-direccion-obra' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="direccion-obra-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintContract.constructionSiteAddress}}</p>

                  <!-- Teléfono Obra -->
                  <label id="t-telefono-obra-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-telefono-obra' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="telefono-obra-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintContract.constructionSitePhone}}</p>

                  <!-- Mecánico  -->
                  <label id="t-mecanico-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-mecanico' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="mecanico-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintContract.mechanicName}}</p>


                  <!-------------------------------------- INFORMACIÓN DEL EQUIPO -------------------------------->
                  <!-- Equipo -->
                  <label id="t-equipo-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-equipo' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="equipo-{{maintenanceOrderPrintContract.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{maintenanceOrderPrintContract.equiptmentName}}</p>

                  <!-- Equipo Código  -->
                  <label id="t-equipo-codigo-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-equipo-codigo' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="equipo-codigo-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintContract.equiptmentCode}}</p>

                  <!-- Equipo código alterno -->
                  <label id="t-equipo-codigo-alterno-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-equipo-codigo-alterno' |
                    formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="equipo-codigo-alterno-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintContract.equipmentAlterCode}}</p>

                  <!-- Equipo Marca -->
                  <label id="t-marca-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-marca' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="marca-{{maintenanceOrderPrintContract.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{maintenanceOrderPrintContract.trademark}}</p>

                  <!-- Equipo Referencia -->
                  <label id="t-referencia-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-referencia' | formatLabelPipe : elementsLabel}}</label>
                  <p id="referencia-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintContract.reference}}</p>

                  <!-- Equipo Serie -->
                  <label id="t-serie-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-serie' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="serie-{{maintenanceOrderPrintContract.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{maintenanceOrderPrintContract.serie}}</p>

                  <!-- Equipo Nombre Comercial -->
                  <label id="t-nombre-comercial-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-nombre-comercial' | formatLabelPipe : elementsLabel}}</label>
                  <p id="nombre-comercial-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintContract.commercialName}}</p>

                  <!-- Equipo Tipo Motor -->
                  <label id="t-tipo-motor-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-tipo-motor' | formatLabelPipe : elementsLabel}}</label>
                  <p id="tipo-motor-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintContract.engineType}}</p>

                  <!-- Equipo Voltaje -->
                  <label id="t-voltaje-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-voltaje' | formatLabelPipe : elementsLabel}}</label>
                  <p id="voltaje-{{maintenanceOrderPrintContract.maintenanceOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{maintenanceOrderPrintContract.voltage}}</p>

                  <!-- Equipo Tipo Equipo -->
                  <label id="t-tipo-equipo-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-tipo-equipo' | formatLabelPipe : elementsLabel}}</label>
                  <p id="tipo-equipo-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintContract.equiptmentType}}</p>

                  <!-- Equipo Potencia -->
                  <label id="t-potencia-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-potencia' | formatLabelPipe : elementsLabel}}</label>
                  <p id="potencia-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintContract.power}}</p>

                  <!-- Equipo Amperaje -->
                  <label id="t-amperaje-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-amperaje' | formatLabelPipe : elementsLabel}}</label>
                  <p id="amperaje-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintContract.amperage}}</p>

                  <!-- PM próximo mtto -->
                  <label id="t-pm-proximo-mtto-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-pm-proximo-mtto' | formatLabelPipe : elementsLabel}}</label>
                  <p id="pm-proximo-mtto-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintContract.nextMaintenancePlan}}</p>

                  <!-- Horómetro próximo mtto -->
                  <label id="t-horometro-proximo-mtto-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-horometro-proximo-mtto' | formatLabelPipe : elementsLabel}}</label>
                  <p id="horometro-proximo-mtto-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{maintenanceOrderPrintContract.nextHourometer}}</p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container mt-2">
                <!--------------------------------------------- Tabla Actividades -------------------------------------->
                <label id="titulo-actividades-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
                  (click)="onClick()">{{'titulo-actividades' |
                  formatLabelPipe : elementsLabel}}</label>
                <div id="container-activities" class="mb-3 mt-1">
                  <app-custom-table-print id="actividades-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                    [columns]="columnsActivities" [data]="maintenanceOrderPrintContract.maintenanceOrderActivities"
                    [idMap]="idMapActivities" [documentId]="maintenanceOrderPrintContract.maintenanceOrderId"
                    [footerVisible]="false" [editFormat]="editFormat" (clickTableEvent)="clickTable($event)"
                    (newIndexColumns)="onColumnActivitiesReorder()"></app-custom-table-print>
                </div>

                <!--------------------------------------------- Tabla Insumos -------------------------------------->
                <div id="container-supplies">
                  <label id="titulo-insumos-{{maintenanceOrderPrintContract.maintenanceOrderId}}" (click)="onClick()"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
                    [hidden]="maintenanceOrderPrintContract.maintenanceOrderSupplies.length === 0">{{'titulo-insumos'
                    |
                    formatLabelPipe : elementsLabel}}</label>
                  <app-custom-table-print [hidden]="maintenanceOrderPrintContract.maintenanceOrderSupplies.length === 0"
                    id="insumos-{{maintenanceOrderPrintContract.maintenanceOrderId}}" [columns]="columnsSupplies"
                    [data]="maintenanceOrderPrintContract.maintenanceOrderSupplies" [idMap]="idMapSupplies"
                    [documentId]="maintenanceOrderPrintContract.maintenanceOrderId" [footerVisible]="false"
                    [editFormat]="editFormat" (clickTableEvent)="clickTable($event)"
                    (newIndexColumns)="onColumnSuppliesReorder($event)"></app-custom-table-print>
                </div>
              </div>
              <div id="foot-{{maintenanceOrderPrintContract.maintenanceOrderId}}" class="foot">
                <!-- Orden de Mantenimiento Diagnóstico Final -->
                <label id="t-diagnostico-final-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-diagnostico-final' | formatLabelPipe : elementsLabel}}</label>
                <p *ngIf="!onBlank" id="diagnostico-final-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                  class="lh-1" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{maintenanceOrderPrintContract.finalDiagnosis}}</p>
                <p *ngIf="!onBlank" id="fecha-diagnostico-final-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{maintenanceOrderPrintContract.dateFinalMaintenanceOrder | date: 'dd/MM/yyyy'}}</p>
                <p id="borde-diagnostico-final-{{maintenanceOrderPrintContract.maintenanceOrderId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>

                <!-- Fecha/Hora Inicio -->
                <label id="t-linea-fecha-inicio-{{ maintenanceOrderPrintContract.maintenanceOrderId }}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{
                  "t-linea-fecha-inicio" | formatLabelPipe : elementsLabel
                  }}</label>
                <p id="linea-fecha-inicio-{{ maintenanceOrderPrintContract.maintenanceOrderId }}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>

                <!-- Fecha/Hora Final -->
                <label id="t-linea-fecha-final-{{ maintenanceOrderPrintContract.maintenanceOrderId }}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{
                  "t-linea-fecha-final" | formatLabelPipe : elementsLabel
                  }}</label>
                <p id="linea-fecha-final-{{ maintenanceOrderPrintContract.maintenanceOrderId }}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>

                <!-- Equipo en operacion -->
                <label id="t-linea-equipo-operacion-{{ maintenanceOrderPrintContract.maintenanceOrderId }}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{ "t-linea-equipo-operacion" | formatLabelPipe : elementsLabel }}</label>
                <p id="linea-equipo-operacion-{{ maintenanceOrderPrintContract.maintenanceOrderId }}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                </p>

                <!-- Horómetro real mtto.  -->
                <label id="t-linea-horometro-real-{{ maintenanceOrderPrintContract.maintenanceOrderId }}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{
                  "t-linea-horometro-real" | formatLabelPipe : elementsLabel
                  }}</label>
                <p id="linea-horometro-real-{{ maintenanceOrderPrintContract.maintenanceOrderId }}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                </p>

                <!-- Conductor -->
                <label id="t-conductor-{{ maintenanceOrderPrintContract.maintenanceOrderId }}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{
                  "t-conductor" | formatLabelPipe : elementsLabel
                  }}</label>
                <p id="conductor-{{ maintenanceOrderPrintContract.maintenanceOrderId }}" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{maintenanceOrderPrintContract.driver}}
                </p>

                <!-- Vehiculo -->
                <label id="t-vehiculo-{{ maintenanceOrderPrintContract.maintenanceOrderId }}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{
                  "t-vehiculo" | formatLabelPipe : elementsLabel }}</label>
                <p id="vehiculo-{{ maintenanceOrderPrintContract.maintenanceOrderId }}" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{maintenanceOrderPrintContract.vehicle}}</p>

                <!-- Vr. Transporte -->
                <label id="t-valor-transporte-{{ maintenanceOrderPrintContract.maintenanceOrderId }}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{
                  "t-valor-transporte" | formatLabelPipe : elementsLabel
                  }}</label>

                <p id="valor-transporte-{{ maintenanceOrderPrintContract.maintenanceOrderId }}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  <ng-container *ngIf="getLabelPrintFormat('valor-transporte'); else currencyFormat">
                    {{ maintenanceOrderPrintContract.transportValue |
                    dynamicFormatPipe:'decimal':getLabelPrintFormat('valor-transporte') }}
                  </ng-container>
                  <ng-template #currencyFormat>
                    {{ maintenanceOrderPrintContract.transportValue | currency }}
                  </ng-template>
                </p>
                <!-- Observación -->
                <label id="t-observacion-manual-{{ maintenanceOrderPrintContract.maintenanceOrderId }}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{
                  "t-observacion-manual" | formatLabelPipe : elementsLabel
                  }}</label>

                <!-- Firma Mecánico-->
                <label id="t-linea-firma-mecanico-{{ maintenanceOrderPrintContract.maintenanceOrderId }}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{ "t-linea-firma-mecanico" | formatLabelPipe : elementsLabel }}</label>
                <p id="linea-firma-mecanico-{{ maintenanceOrderPrintContract.maintenanceOrderId }}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                </p>

                <!-- Firma Operador-->
                <label id="t-linea-firma-operador-{{ maintenanceOrderPrintContract.maintenanceOrderId }}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{
                  "t-linea-firma-operador" | formatLabelPipe : elementsLabel
                  }}</label>
                <p id="linea-firma-operador-{{ maintenanceOrderPrintContract.maintenanceOrderId }}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>

                <!-- Firma Jefe Mantenimiento-->
                <label id="t-linea-firma-jefe-mantenimiento-{{ maintenanceOrderPrintContract.maintenanceOrderId }}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{ "t-linea-firma-jefe-mantenimiento" | formatLabelPipe : elementsLabel }}</label>
                <p id="linea-firma-jefe-mantenimiento-{{ maintenanceOrderPrintContract.maintenanceOrderId }}"
                  class="write-line" (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                </p>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="1">
              <div class="row">
                <div class="col-12 d-flex gap-2">
                  <!-- Versión CW-->
                  <p class="label-footer-page">{{version}}</p>

                  <!-- Fecha Impresión-->
                  <label class="label-footer-page">Fecha</label>
                  <p class="footer-page">{{dateNow | date: 'dd/MM/yyyy'}}</p>

                  <!-- Hora Impresión-->
                  <label class="label-footer-page">Hora:</label>
                  <p class="footer-page">{{dateNow | date: 'hh:mm:ss a'}}</p>

                  <!-- Usuario Impresión-->
                  <label class="label-footer-page">Usuario:</label>
                  <p class="footer-page">{{userAuthenticated}}</p>
                </div>
              </div>
              <p id="message"></p>
            </td>
          </tr>
        </tfoot>
      </table>